import { render, staticRenderFns } from "./SiteManagement.vue?vue&type=template&id=42352588&scoped=true&"
import script from "./SiteManagement.vue?vue&type=script&lang=ts&"
export * from "./SiteManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42352588",
  null
  
)

export default component.exports